import React, { useContext, useEffect, useState, useMemo } from 'react';
import {
    Box, Chip, Dialog, Divider, Checkbox, Slide, Typography, IconButton,
    Accordion, AccordionSummary, AccordionDetails, List, ListItem,
    ListItemText, Badge, Tab, Button, Stack, ToggleButtonGroup, ToggleButton
} from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PAContext } from "../../../Services/PAContext";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import SupplyItem from "../../../MasterEventObjects/SupplyItem";
import { suppliesSuggestionList, foodSuggestionList } from '../../../sampleData/SupplyItemSuggestions';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function SuppliesAddSuggestionsDialog({ open, onClose, selectedAttendeeId }) {
    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();
    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account } = dataArray;

    const [tabValue, setTabValue] = useState("supplies");
    const [suppliesChecked, setSuppliesChecked] = useState([]);
    const [foodChecked, setFoodChecked] = useState([]);

    useEffect(() => {
        if (open) {
            setSuppliesChecked([]);
            setFoodChecked([]);
            setTabValue("supplies");
        }
    }, [open]);

    const handleAddItems = () => {
        const allNewItems = [...suppliesChecked, ...foodChecked];
        if (allNewItems.length === 0) return;

        set_PA_GlobalObject((prev) => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                supplies: [...(prev.Planning.supplies || []), ...allNewItems]
            }
        }));

        if (PA_GlobalObject.Planning.status !== 10) {
            allNewItems.forEach(item => {
                sendSocketMessage({
                    action: "E_addNewSupplyItem",
                    event_id: PA_GlobalObject.Planning.id,
                    supply_item: item
                });
            });
        }
        onClose();
    };

    const toggleItem = (list, setList, subcategory, itemName, category) => {
        const exists = list.find(i => i.sub_category === subcategory && i.name === itemName);
        if (exists) {
            setList(list.filter(i => !(i.sub_category === subcategory && i.name === itemName)));
        } else {
            const newItem = new SupplyItem();
            newItem.name = itemName;
            newItem.category = category;
            newItem.sub_category = subcategory;
            newItem.assigned_by = Account.id;
            newItem.assigned_to = selectedAttendeeId || Account.id || "0";
            setList([...list, newItem]);
        }
    };

    const updateItemProperty = (list, setList, subcategory, itemName, key, value) => {
        setList(list.map(i =>
            (i.sub_category === subcategory && i.name === itemName) ? { ...i, [key]: value } : i
        ));
    };

    const renderCategorySection = (dataList, checkedList, setCheckedList, categoryLabel) => {
        return Object.keys(dataList).sort().map((subcategory) => {
            const subCount = checkedList.filter(i => i.sub_category === subcategory).length;
            return (
                <Accordion
                    key={subcategory}
                    disableGutters
                    sx={{
                        boxShadow: 'none',
                        borderBottom: '1px solid #f1f3f5',
                        '&:before': { display: 'none' }, // Remove default line
                        bgcolor: 'transparent'
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#151269' }} />}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Typography sx={{ fontWeight: 800, fontSize: '0.95rem', color: '#1e293b' }}>
                                {subcategory}
                            </Typography>
                            {subCount > 0 && (
                                <Chip
                                    label={subCount}
                                    size="small"
                                    sx={{ bgcolor: '#151269', color: '#fff', height: 18, fontSize: '10px', fontWeight: 900 }}
                                />
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 1.5, pt: 0 }}>
                        <List disablePadding>
                            {dataList[subcategory].sort().map((itemName) => {
                                const isChecked = checkedList.find(i => i.sub_category === subcategory && i.name === itemName);
                                return (
                                    <Box key={itemName} sx={{ mb: 1, borderRadius: '12px', bgcolor: isChecked ? 'rgba(21, 18, 105, 0.04)' : '#fff', border: isChecked ? '1.5px solid #151269' : '1px solid #eef0f2', transition: 'all 0.2s' }}>
                                        <ListItem
                                            secondaryAction={
                                                <Checkbox
                                                    edge="end"
                                                    checked={!!isChecked}
                                                    onChange={() => toggleItem(checkedList, setCheckedList, subcategory, itemName, categoryLabel)}
                                                    sx={{ color: '#cbd5e1', '&.Mui-checked': { color: '#151269' } }}
                                                />
                                            }
                                        >
                                            <ListItemText
                                                primary={itemName}
                                                primaryTypographyProps={{ fontWeight: isChecked ? 800 : 500, color: isChecked ? '#151269' : '#2c3e50', fontSize: '14px' }}
                                            />
                                        </ListItem>

                                        {isChecked && (
                                            <Stack sx={{ px: 2, pb: 2 }} spacing={1}>
                                                <Divider sx={{ mb: 1, borderStyle: 'dashed' }} />
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <ToggleButtonGroup
                                                        fullWidth
                                                        size="small"
                                                        exclusive
                                                        value={isChecked.private}
                                                        onChange={(e, val) => val !== null && updateItemProperty(checkedList, setCheckedList, subcategory, itemName, 'private', val)}
                                                        sx={{ bgcolor: '#fff', p: 0.3, borderRadius: '8px', border: '1px solid #eef0f2' }}
                                                    >
                                                        <ToggleButton value={false} sx={{ py: 0.5, fontSize: '10px', fontWeight: 700, border: 'none !important', borderRadius: '6px !important' }}>Public</ToggleButton>
                                                        <ToggleButton value={true} sx={{ py: 0.5, fontSize: '10px', fontWeight: 700, border: 'none !important', borderRadius: '6px !important' }}>Private</ToggleButton>
                                                    </ToggleButtonGroup>

                                                    <ToggleButtonGroup
                                                        fullWidth
                                                        size="small"
                                                        exclusive
                                                        value={isChecked.essential}
                                                        onChange={(e, val) => val !== null && updateItemProperty(checkedList, setCheckedList, subcategory, itemName, 'essential', val)}
                                                        sx={{ bgcolor: '#fff', p: 0.3, borderRadius: '8px', border: '1px solid #eef0f2' }}
                                                    >
                                                        <ToggleButton value={true} sx={{ py: 0.5, fontSize: '10px', fontWeight: 700, border: 'none !important', borderRadius: '6px !important', '&.Mui-selected': { color: '#27ae60' } }}>✨ Essential</ToggleButton>
                                                        <ToggleButton value={false} sx={{ py: 0.5, fontSize: '10px', fontWeight: 700, border: 'none !important', borderRadius: '6px !important' }}>One-time</ToggleButton>
                                                    </ToggleButtonGroup>
                                                </Box>
                                            </Stack>
                                        )}
                                    </Box>
                                );
                            })}
                        </List>
                    </AccordionDetails>
                </Accordion>
            );
        });
    };

    const totalCount = suppliesChecked.length + foodChecked.length;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: { borderRadius: '20px', backgroundColor: '#fff', overflow: 'hidden' } }}
        >
            {/* COMMON HEADER */}
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f1f3f5' }}>
                <Box>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#151269' }}>Suggestions</Typography>
                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#95a5a6', letterSpacing: 0.5 }}>BROWSE CATALOG</Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ color: '#e74c3c', backgroundColor: 'rgba(231, 76, 60, 0.1)', '&:hover': { backgroundColor: 'rgba(231, 76, 60, 0.2)' } }}>
                    <i className="icon-cross" />
                </IconButton>
            </Box>

            <TabContext value={tabValue}>
                <Box sx={{ px: 2, pt: 1, bgcolor: '#fff' }}>
                    <TabList
                        onChange={(e, v) => setTabValue(v)}
                        variant="fullWidth"
                        sx={{
                            minHeight: 40,
                            '& .MuiTabs-indicator': { display: 'none' }
                        }}
                    >
                        <Tab
                            label={`Supplies ${suppliesChecked.length > 0 ? `(${suppliesChecked.length})` : ''}`}
                            value="supplies"
                            sx={{ borderRadius: '12px', fontWeight: 800, fontSize: '13px', textTransform: 'none', color: '#95a5a6', '&.Mui-selected': { color: '#151269', bgcolor: '#f1f3f5' } }}
                        />
                        <Tab
                            label={`Food ${foodChecked.length > 0 ? `(${foodChecked.length})` : ''}`}
                            value="food"
                            sx={{ borderRadius: '12px', fontWeight: 800, fontSize: '13px', textTransform: 'none', color: '#95a5a6', '&.Mui-selected': { color: '#151269', bgcolor: '#f1f3f5' } }}
                        />
                    </TabList>
                </Box>

                <Box sx={{ overflowY: 'auto', flexGrow: 1, maxHeight: '60vh', bgcolor: '#f8f9fa' }}>
                    <TabPanel value="supplies" sx={{ p: 1 }}>
                        {renderCategorySection(suppliesSuggestionList, suppliesChecked, setSuppliesChecked, "supplies")}
                    </TabPanel>
                    <TabPanel value="food" sx={{ p: 1 }}>
                        {renderCategorySection(foodSuggestionList, foodChecked, setFoodChecked, "food")}
                    </TabPanel>
                </Box>
            </TabContext>

            {/* COMMON FOOTER */}
            <Box sx={{ p: 2, borderTop: '1px solid #f1f3f5', display: 'flex', gap: 2, bgcolor: '#fff' }}>
                <Button fullWidth onClick={onClose} sx={{ py: 1.5, borderRadius: '12px', fontWeight: 800, color: '#95a5a6', bgcolor: '#f8f9fa' }}>
                    Cancel
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleAddItems}
                    disabled={totalCount === 0}
                    sx={{
                        py: 1.5,
                        borderRadius: '12px',
                        fontWeight: 800,
                        bgcolor: '#151269',
                        '&:hover': { bgcolor: '#1a1780' },
                        boxShadow: '0 4px 14px rgba(21, 18, 105, 0.25)',
                        '&.Mui-disabled': { bgcolor: '#bdc3c7', color: '#fff' }
                    }}
                >
                    {totalCount === 0 ? 'Add Items' : `Add ${totalCount} Items`}
                </Button>
            </Box>
        </Dialog>
    );
}

export default SuppliesAddSuggestionsDialog;